import { X } from "lucide-react";

const CommonModalWrapper = ({
  isOpen,
  onClose,
  children,
  maxWidth = "md",
}: any) => {
  if (!isOpen) return null;

  // Map maxWidth prop to Tailwind classes
  const maxWidthClasses: any = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "max-w-2xl",
    "3xl": "max-w-3xl",
    "4xl": "max-w-4xl",
    "5xl": "max-w-5xl",
    full: "max-w-full",
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div
        className={`bg-white rounded-xl shadow-2xl w-full ${
          maxWidthClasses[maxWidth] || "max-w-md"
        } max-h-[90vh] overflow-y-auto relative`}
      >
        <div className="absolute top-4 right-4 z-10">
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
            aria-label="Close"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        <div className="p-8">{children}</div>
      </div>
    </div>
  );
};

export default CommonModalWrapper;
